import React from "react";

function UpdatesSection() {
  return (
    <section className="updates-section">
      <div className="updates-card">
        <h2 className="updates-title">Latest News & Announcements</h2>

        <div className="news-ticker">
          <ul className="ticker-list">
            <li>
                Best paper award to Paper ID 280, titled “PDSTA: A Gated Parallel Spatio-Temporal Attention Network for Real-Time Home Rehabilitation Monitoring,” authored by Rishi Rokariya, Sameeksha Jain, and Srimanta Mandal of Dhirubhai Ambani University.
            </li>
                        
          </ul>
        </div>
      </div>

      <style jsx>{`
        .updates-section {
          padding-top: 60px;
          display: flex;
          background: #ECEEDF;
          justify-content: center;   
          align-items: center;      
        }

        .updates-card {
          background: #ffffff;
          width: 100%;
          max-width: 800px;
          padding: 30px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          text-align: left;          
        }

        .updates-title {
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 20px;
          color: red;
          text-align: center;       
        }

        .news-ticker {
          height: 80px;
          overflow: hidden;
          position: relative;
        }

        .ticker-list {
          list-style: none;
          padding: 0;
          margin: 0;
          animation: scrollUp 12s linear infinite;
        }

        .ticker-list li {
          padding: 10px 0;
          font-size: 16px;
          color: red;
          border-bottom: 1px solid #eee;
        }

        .ticker-list li a {
          color: red;
          text-decoration: none;
        }

        .ticker-list li a:hover {
          text-decoration: underline;
        }

        @keyframes scrollUp {
          0% {
            transform: translateY(100%);
          }
          100% {
            transform: translateY(-100%);
          }
        }

        .news-ticker:hover .ticker-list {
          animation-play-state: paused;
        }

        @media (max-width: 576px) {
          .updates-card {
            padding: 20px;
          }
          .updates-title {
            font-size: 20px;
          }
          .ticker-list li {
            font-size: 14px;
          }
        }
      `}</style>
    </section>
  );
}

export default UpdatesSection;
